import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { MarketplaceBuyer } from '../models/buyer';

// #931: fetches the caller's OWN buyer profile scoped server-side to what a seller sees
// (viewAs=seller strips buyer-only content and private uploads; sellerWithDataNda keeps
// private uploads). Stored separately from targetBuyer so the edit tabs stay untouched.
export const GetOwnBuyerSellerPreview = createAsyncThunk(
    'marketplaceBuyers/getOwnBuyerSellerPreview',
    async (params: { withDataNda: boolean }, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const viewAs = params.withDataNda ? 'sellerWithDataNda' : 'seller';
            const response = await axios.get(
                `/api/Marketplace/MarketplaceBuyers?viewAs=${viewAs}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not load the seller preview at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch seller preview');
            }

            return {
                buyer: response.data as MarketplaceBuyer,
            };
        } catch (error) {
            createNotification(
                'An error occurred while loading the seller preview.',
                'error'
            );
            throw error;
        }
    }
);
